import {Grid, Typography} from '@logistics-frontend/blocks'
import React, {useMemo} from 'react'

import {SharedRouteInfoResponse} from 'src/api/cargo-c2c/types'
import pathToCar from 'src/assets/car.png'
import {useFeedbackSubtitle} from 'src/pages/route/hooks'
import {infoGet} from 'src/utils'

import CustomIcon from './CustomIcon'
import {classes} from './Status.classes'
import {renderVehiclePlate} from './Status.utils'

type Props = {
  info: SharedRouteInfoResponse
}

function Status({info}: Props): React.ReactElement {
  const subtitle = useFeedbackSubtitle()
  const vehicleNumber = infoGet('performer.vehicle_number', info)
  const vehiclePlate = useMemo(() => renderVehiclePlate(vehicleNumber), [vehicleNumber])

  return (
    <Grid alignItems="center" className={classes.formTitle} wrap="nowrap" container>
      <Grid item xs>
        <Typography thickness="medium" variant="body1">
          {info.summary}
        </Typography>
        <Typography mt="xs" variant="caption1">
          {subtitle || info.description}
        </Typography>
      </Grid>
      {vehiclePlate.length > 0 && (
        <Grid item>
          <div className={classes.plate}>
            {vehiclePlate}
            <img alt="" className={classes.plateCar} loading="lazy" src={pathToCar} />
          </div>
        </Grid>
      )}
      {info.icon_strategy?.image_tag && (
        <Grid item>
          <div className={classes.plateImage}>
            <CustomIcon imageTag={info.icon_strategy.image_tag} />
          </div>
        </Grid>
      )}
    </Grid>
  )
}

export default Status
